import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './App.css';

// Pages
import HomePage from './pages/HomePage';
import IntegrationPage from './pages/IntegrationPage';
import AboutPage from './pages/AboutPage';
import AIAutomationPage from './pages/AIAutomationPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import FractionalAdvisory from './pages/FractionalAdvisoryPage';
import CarbonCalculatorPage from './pages/CarbonCalculatorPage';

// Initialize Google Analytics
ReactGA.initialize('G-3LX6FH55L7');

// Component to track page views on route changes
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    });
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <PageTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/services/integration" element={<IntegrationPage />} />
        <Route path="/services/automation" element={<AIAutomationPage />} />
        <Route path="/services/fractional" element={<FractionalAdvisory />} />
        <Route path="/tools/freight-carbon-calculator" element={<CarbonCalculatorPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
};

export default App;
